import React from 'react'
import { AddTeamLayer } from '../components/team/AddTeamLayer'
import MasterLayout from '../masterLayout/MasterLayout'

export const AddTeamPage = () => {
  return (
    <MasterLayout>

        <AddTeamLayer/>
    </MasterLayout>
  )
}
